import {Nullable} from '../../../app/TypeHelpers'
import {AVAILABLE_OR_NOT, ROLE_FOR_ADMINISTRATOR, VALID_OR_NOT} from '../../../CodeMaster'
import {Moment} from 'moment'
import {Room} from './Room'

export default class Meeting {
    id: number
    name: string
    date: Nullable<string>
    startTime: Nullable<string>
    endTime: Nullable<string>
    place: Nullable<string>
    url: Nullable<string>
    contents: Nullable<string>
    memo: Nullable<string>
    attendanceReplyDeadline: Nullable<Moment>
    attendanceReplyRequestDatetime: Nullable<Moment>
    manageAttendance: VALID_OR_NOT
    proxyAttendanceAvailability: Nullable<AVAILABLE_OR_NOT>
    meetingAnnounceNotifyDatetime: Nullable<Moment>
    meetingAttachmentFileList: MeetingAttachment[]
    meetingAttachmentLinkList: MeetingAttachment[]
    meetingReportList: MeetingAttachment[]
    version: number

    constructor(
        id: number,
        name: string,
        date: Nullable<string>,
        startTime: Nullable<string>,
        endTime: Nullable<string>,
        place: Nullable<string>,
        url: Nullable<string>,
        contents: Nullable<string>,
        memo: Nullable<string>,
        attendanceReplyDeadline: Nullable<Moment>,
        attendanceReplyRequestDatetime: Nullable<Moment>,
        manageAttendance: VALID_OR_NOT,
        proxyAttendanceAvailability: Nullable<AVAILABLE_OR_NOT>,
        meetingAnnounceNotifyDatetime: Nullable<Moment>,
        meetingAttachmentFileList: MeetingAttachment[],
        meetingAttachmentLinkList: MeetingAttachment[],
        meetingReportList: MeetingAttachment[],
        version: number,
    ) {
        this.id = id
        this.name = name
        this.date = date
        this.startTime = startTime
        this.endTime = endTime
        this.place = place
        this.url = url
        this.contents = contents
        this.memo = memo
        this.attendanceReplyDeadline = attendanceReplyDeadline
        this.attendanceReplyRequestDatetime = attendanceReplyRequestDatetime
        this.manageAttendance = manageAttendance
        this.meetingAnnounceNotifyDatetime = meetingAnnounceNotifyDatetime
        this.proxyAttendanceAvailability = proxyAttendanceAvailability
        this.meetingAttachmentFileList = meetingAttachmentFileList
        this.meetingAttachmentLinkList = meetingAttachmentLinkList
        this.meetingReportList = meetingReportList
        this.version = version
    }
}

export function getManageAttendanceInfo(meeting: Meeting): Nullable<ManageAttendanceInfo> {
    if (meeting.manageAttendance === VALID_OR_NOT.NOT) {
        return null
    }
    if (meeting.attendanceReplyDeadline === null
        || meeting.proxyAttendanceAvailability === null) {
        // データが不正
        return null
    }
    return {
        attendanceReplyDeadline: meeting.attendanceReplyDeadline,
        attendanceReplyRequestDatetime: meeting.attendanceReplyRequestDatetime,
        proxyAttendanceAvailability: meeting.proxyAttendanceAvailability,
    }
}

export interface MeetingAttachment {
    id: number
    displayName: string
    uri: string
    registeredDatetime: string
    registeredUserFirstName: string
    registeredUserFamilyName: string
    roleId: ROLE_FOR_ADMINISTRATOR
    roomList: Room[]
    version: number
}

export interface MeetingAttachmentResoponse extends Omit<MeetingAttachment, 'roleId'> {
    roleId: string
}


export interface ManageAttendanceInfo {
    attendanceReplyDeadline: Moment
    attendanceReplyRequestDatetime: Nullable<Moment>
    proxyAttendanceAvailability: AVAILABLE_OR_NOT
}
